import { StyleSheet } from "@react-pdf/renderer";

import { MEDIUM_GREY, PRIMARY_COLOR, PRIMARY_RED_COLOR,PRIMARY_BLACK } from "constants/globalConstants";

const styles = StyleSheet.create({
  page: {
    marginBottom: 50
  },
  body: {
    paddingTop: 35,
    paddingBottom: 65
  },
  title: {
    fontSize: 24,
    textAlign: "center"
  },
  text: {
    margin: 12,
    fontSize: 14,
    textAlign: "justify"
  },
  header: {
    fontSize: 12,
    marginBottom: 20,
    textAlign: "center",
    color: MEDIUM_GREY,
    marginTop: 20
  },
  pageNumber: {
    position: "absolute",
    bottom: 30,
    left: 0,
    right: 0,
    textAlign: "center",
    color: MEDIUM_GREY,
    fontSize: 12
  },
  waterSolutionImage: {
    height: 20,
    width: 200,
    resizeMode: "cover",
    paddingHorizontal: 35,
    marginBottom: 20,
    justifyContent: "center"
  },
  infoIconImage: {
    height: 18,
    width: 21
  },
  predictionNoteContainer: {
    alignItems: "center",
    flexDirection: "row",
    marginHorizontal: 10,
    marginTop: 10
  },
  predictionNote: {
    fontSize: 15,
    color: PRIMARY_COLOR,
    marginTop: 1,
    marginHorizontal: 3
  },
  dupontLogoImage: {
    marginLeft: "auto",
    width: 200,
    resizeMode: "cover",
    paddingHorizontal: 35,
    height: 40,
    marginBottom: 20,
    justifyContent: "center"
  },
  footer: {
    flexDirection: "row",
    paddingHorizontal: 35,
    marginTop: 50
  },
  desalitext: {
    fontSize: 40,
    marginTop: 40
  },
  mainPageTitleTopMiddle: {
    fontSize: 13,
    marginTop: 40,
    left:-15
  },
  error: {
    color: PRIMARY_RED_COLOR,
    fontSize: 13,
    paddingHorizontal: 35,
    marginTop: 10
  },
  contentPage: {
    paddingBottom: 65
  },
  comment: {
    marginTop: 10,
    fontSize: 14,
    marginHorizontal: 35,
    color: PRIMARY_BLACK
  },
  link: {
    marginLeft: "auto",
    color: PRIMARY_RED_COLOR,
    fontSize: 13,
    right: 5,
    marginTop: 90
  },
  widgetImage: {
    width: 480,
    justifyContent: "center",
    alignSelf: "center",
    marginTop: 20
  },
  reportTitle: {
    marginTop: 30,
    fontSize: 16,
    textAlign: "center",
    fontWeight: "bold"
  },
  ccroTitle: {
    fontSize: 37,
    marginTop: 40,
    color: PRIMARY_COLOR,
    paddingHorizontal: 35
  },
  marginTop5: {
    marginTop: 5
  },
  titleContainer: {
    flexDirection: "row",
    paddingHorizontal: 35
  },
  flexRow: {
    flexDirection: "row"
  },
  tag: {
    border: 3,
    borderColor: MEDIUM_GREY,
    borderStyle: "solid",
    margin: 35,
    padding: 20,
    flexWrap: "wrap",
    justifyContent: "center",
    alignItems: "center"
  },
  tagContainer: {
    paddingHorizontal: 35
  },
  tagMainContainer: {
    border: 1,
    borderColor: MEDIUM_GREY,
    borderStyle: "solid",
    padding: 20,
    flexWrap: "wrap",
    flexDirection: "row",
    margin: 10,
    justifyContent: "center",
    alignItems: "center",
    paddingHorizontal: 35,
    marginHorizontal: 35,
    maxWidth: 400,
    minWidth: 400,
    alignSelf: "center",
    alignContent: "center"
  },
  tagText: {
    fontSize: 24,
    color: PRIMARY_COLOR,
    fontWeight: "bold"
  },
  noAlarms: {
    flexWrap: "wrap",
    justifyContent: "center",
    alignItems: "center",
    alignSelf: "center",
    marginHorizontal: 35
  },
  systemDetail: {
    marginTop: 5,
    fontWeight: "thin"
  },
 subtitle: {
  
  fontSize: 8,
  color: MEDIUM_GREY,
  textAlign: "center"
 }
});

export default styles;
